import React from 'react';
import {Field, reduxForm} from "redux-form";
import TextField from "@material-ui/core/TextField";
import {ThemeProvider, withStyles} from '@material-ui/core/styles';
import {theme} from "../../Dashboard/theme";
import Container from "@material-ui/core/Container";
import Button from "@material-ui/core/Button";
import CssBaseline from '@material-ui/core/CssBaseline';
import styles from "../../Signup/SignupStyles";
import Avatar from "@material-ui/core/Avatar";
import Grid from "@material-ui/core/Grid";
import FormHelperText from '@material-ui/core/FormHelperText'
import {Link as RouterLink} from 'react-router-dom'
import TextareaAutosize from '@material-ui/core/TextareaAutosize';
import FavoriteBorderIcon from '@material-ui/icons/FavoriteBorder';

let themeCustom = {
  ...theme,
};

// eslint-disable-next-line
const validate = values => {
  const errors = {};

  const requiredFields = [
    'firstName',
    'lastName',
    'email',
    'role'
  ];

  requiredFields.forEach(field => {
    if (!values[field]) {
      errors[field] = 'Required'
    }
  });

  if (
    values.email &&
    !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)
  ) {
    errors.email = 'Invalid email address'
  }
  return errors
};

// eslint-disable-next-line
const renderFromHelper = ({touched, error}) => {
  if (!(touched && error)) {
    return
  } else {
    return <FormHelperText>{touched && error}</FormHelperText>
  }
};

class NewConnectionForm extends React.Component {
  renderError({error, touched}) {
    if (touched && error) {
      return (
        <div className="ui error message">
          <div className="header">{error}</div>
        </div>
      );
    }
  }

  renderTextField = ({
                       input, label,
                       meta: {touched, invalid, error},
                       ...custom
                     }) => (
    <TextField
      style={{marginTop: '1px'}}
      label={label}
      placeholder={label}
      error={touched && invalid}
      helperText={touched && invalid && error}
      variant="outlined"
      margin="normal"
      fullWidth
      {...input}
      {...custom}
    />
  );

  renderTextArea = ({
                       input, label,
                       meta: {touched, invalid, error},
                       ...custom
                     }) => (
    <TextareaAutosize
      rowsMin={3}
      aria-label="minimum height"
      placeholder="Enter emotional connection..."
      style={{marginTop: '1px'}}
      label={label}
      error={touched && invalid}
      helperText={touched && invalid && error}
      // variant="outlined"
      // margin="normal"
      {...input}
      {...custom}
    />
  );

  onSubmit = (formValues) => {
    this.props.onSubmit(formValues);
  };

  render() {
    const {classes} = this.props;
    return (
      <ThemeProvider theme={themeCustom}>
          <CssBaseline/>
          <Container className={classes.paper}
                     style={{
                       marginTop: "1px",
                       flex: "1 0 auto",
                       maxWidth: "600px"
                     }}>
            <Avatar className={classes.avatar}
                    style={{
                      color: "white",
                      backgroundColor:
                      theme.palette.primary.light
                    }}>
              <FavoriteBorderIcon fontSize="large"/>
            </Avatar>
            <Grid>
                <Container>
                  <form
                    onSubmit={this.props.handleSubmit(this.props.onSubmit)}
                    className={classes.form}
                    noValidate
                  >
                    <Grid container spacing={2}>
                      <Grid item xs={12}>
                        <Field
                          name="physicalIssue"
                          component={this.renderTextField}
                          label="Physical Issue"
                          required
                          autoFocus
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <Field
                          className={classes.textArea}
                          name="emotionalLink"
                          component={this.renderTextArea}
                          label="Emotional Link"
                          required/>
                      </Grid>
                      <Grid container justify="center" style={{marginTop: '16px'}}>
                        <Button type="submit" variant="contained" color="primary" fullWidth>Submit</Button>
                      </Grid>
                      <Grid container justify="center" style={{marginTop: '16px'}}>
                        <Button variant="contained"
                                color="grey"
                                fullWidth
                                component={RouterLink}
                                to="/dashboard/admin/connections"
                        >Cancel</Button>
                      </Grid>
                    </Grid>
                  </form>
                </Container>
            </Grid>
          </Container>
      </ThemeProvider>
    );
  }
}

const doValidate = (formValues) => {
  const errors = {};
  if (!formValues.title) {
    // Runs if the user doesn't enter a title
    errors.title = 'You must enter a title';
  }
  if (!formValues.description) {
    // Runs if the user doesn't enter a title
    errors.description = 'You must enter a description';
  }
  return errors;
};

NewConnectionForm = withStyles(styles, {withTheme: true})(NewConnectionForm);

export default reduxForm({
  form: 'userForm',
  validate: doValidate
})(NewConnectionForm);

